import { createWebHistory, createRouter } from "vue-router";
import RedMain from "@/pages/main/RedMain";
import RedConditions from "@/pages/main/RedConditions.vue";
import Repayment from "@/pages/main/payment/RedRepayment.vue";
import Prepayment from "@/pages/main/payment/RedPrepayment.vue";
import RepaymentSuccess from "@/pages/main/payment/RedRepaymentSuccess.vue";
import PrepaymentSuccess from "@/pages/main/payment/RedPrepaymentSuccess.vue";
import PageNotFound from "@/pages/shared/PageNotFound.vue";
import RedTips from "@/pages/main/RedTips.vue";
import RedClose from "@/pages/main/RedClose.vue";
import RedCloseTransfer from "@/pages/main/RedCloseTransfer.vue";
import RedCloseReason from "@/pages/main/RedCloseReason.vue";
import RedCloseSuccess from "@/pages/main/RedCloseSuccess.vue";
import RedIncreaseLimitSuccess from "@/pages/main/RedIncreaseLimitSuccess.vue";
import RedCalendar from "@/pages/main/RedCalendar.vue";
import RedReduceLimit from "@/pages/main/RedReduceLimit.vue";
import RedCloseStatement from "@/pages/main/RedCloseStatement.vue";
import RedIncreaseLimit from "@/pages/main/RedIncreaseLimit.vue";
import RedArrest from "@/pages/main/RedArrest.vue";
import RedOnlineStub from "@/pages/main/RedOnlineStub.vue";
import ConsentPage from "@/pages/main/ConsentPage.vue";
import ConsentAgreement from "@/pages/main/ConsentAgreement.vue";
import { getDeviceType } from "@/utils/device";
import "@/jsdoc/types";

/**
 * @typedef {Object} Route
 * @property {string} path
 * @property {string} name
 * @property {HeaderModel} meta
 * @property {any} component
 */

const routes = [
  {
    path: "/Bank/Red/Conditions",
    name: "RedConditions",
    component: RedConditions,
    meta: {
      title: "Условия участия",
      additionalClass: "",
      logo: "",
      backRoute: "default",
      shadowed: true,
    },
  },
  {
    path: "/Bank/Red",
    name: "RedMain",
    component: RedMain,
    meta: {
      title: "Мой Банк",
      additionalClass: "",
      logo: "i-kaspi-logo",
      backRoute: "/bank",
      shadowed: true,
    },
  },
  {
    path: "/Bank/Red/arrest/:id?",
    name: "RedArrest",
    component: RedArrest,
    meta: {
      title: "Ограничение счета",
      additionalClass: "",
      logo: "",
      backRoute: "default",
      shadowed: true,
    },
  },
  {
    path: "/Bank/Red/RedPrepayment",
    name: "RedPrepayment",
    component: Prepayment,
    meta: {
      title: "Досрочное погашение",
      additionalClass: "",
      logo: "",
      backRoute: "default",
      shadowed: true,
    },
  },
  {
    path: "/Bank/Red/RedPrepayment/success",
    name: "RedPrepaymentSuccess",
    component: PrepaymentSuccess,
    meta: {
      title: "Kaspi Red",
      additionalClass: "",
      logo: "i-kaspi-logo",
      backRoute: "/bank/red",
      shadowed: true,
    },
  },
  {
    path: "/Bank/Red/RedRepayment/:id?",
    name: "RedRepayment",
    component: Repayment,
    meta: {
      title: "Оплата счета Kaspi Red",
      additionalClass: "",
      logo: "",
      backRoute: "default",
      shadowed: true,
    },
  },
  {
    path: "/Bank/Red/RedRepayment/success",
    name: "RedRepaymentSuccess",
    component: RepaymentSuccess,
    meta: {
      title: "Kaspi Red",
      additionalClass: "",
      logo: "i-kaspi-logo",
      backRoute: "/bank/red",
      shadowed: false,
    },
  },
  {
    component: RedTips,
    path: "/Bank/Red/Tips",
    name: "RedTips",
    meta: {
      title: "Полезные советы",
      additionalClass: "tips",
      logo: "",
      backRoute: "default",
      shadowed: true,
    },
  },
  {
    component: RedCloseTransfer,
    path: "/Bank/Red/close/transfer",
    name: "RedCloseTransfer",
    meta: {
      title: "Закрытие Kaspi Red",
      additionalClass: "",
      logo: "",
      backRoute: "/bank",
      shadowed: true,
    },
  },
  {
    path: "/Bank/Red/PaymentCalendar",
    name: "RedCalendar",
    component: RedCalendar,
    meta: {
      title: "Календарь счетов",
      additionalClass: "",
      logo: "",
      backRoute: "default",
      shadowed: true,
    },
  },
  {
    path: "/Bank/Red/limits",
    name: "RedIncreaseLimit",
    component: RedIncreaseLimit,
    meta: {
      title: "Увеличение лимита",
      additionalClass: "",
      logo: "",
      backRoute: "default",
      shadowed: true,
    },
  },
  {
    path: "/Bank/Red/limits/success",
    name: "RedIncreaseLimitSuccess",
    component: RedIncreaseLimitSuccess,
    meta: {
      title: "Kaspi Red",
      additionalClass: "",
      logo: "i-kaspi-logo",
      backRoute: "/bank/red",
      shadowed: false,
    },
  },
  {
    path: "/Bank/Red/close/reason",
    name: "RedCloseReason",
    component: RedCloseReason,
    meta: {
      title: "Закрытие Kaspi Red",
      additionalClass: "",
      logo: "",
      backRoute: "default",
      shadowed: true,
    },
  },
  {
    path: "/Bank/Red/close/success",
    name: "RedCloseSuccess",
    component: RedCloseSuccess,
    meta: {
      title: "Закрытие Kaspi Red",
      additionalClass: "",
      logo: "",
      backRoute: "/bank",
      shadowed: true,
    },
  },
  {
    path: "/Bank/Red/OnlineStub/:stubAmount?",
    name: "RedOnlineStub",
    component: RedOnlineStub,
    meta: {
      title: "Kaspi Red",
      additionalClass: "",
      logo: "i-kaspi-logo",
      backRoute: "default",
      shadowed: true,
    },
  },
  {
    path: "/Bank/Red/reduce-limit",
    name: "RedReduceLimit",
    component: RedReduceLimit,
    meta: {
      title: "Уменьшить лимит",
      additionalClass: "",
      logo: "",
      backRoute: "default",
      shadowed: true,
    },
  },
  {
    path: "/Bank/Red/Close",
    name: "RedClose",
    component: RedClose,
    meta: {
      title: "Закрытие Kaspi Red",
      additionalClass: "",
      logo: "",
      backRoute: "default",
      shadowed: true,
    },
  },
  {
    path: "/Bank/Red/Close/Statement",
    name: "RedCloseStatement",
    component: RedCloseStatement,
    meta: {
      title: "Заявление",
      additionalClass: "",
      logo: "",
      backRoute: "default",
      shadowed: getDeviceType() === "ios",
    },
  },
  {
    path: "/Bank/Red/Consent",
    name: "ConsentPage",
    component: ConsentPage,
    meta: {
      title: "Kaspi Red",
      additionalClass: "",
      logo: "",
      backRoute: "/bank/red",
      shadowed: true,
    },
  },
  {
    path: "/Bank/Red/Agreement",
    name: "ConsentAgreement",
    component: ConsentAgreement,
    meta: {
      title: "Kaspi Red",
      additionalClass: "",
      logo: "",
      backRoute: "default",
      shadowed: getDeviceType() === "ios",
    },
  },
  {
    /*Этот роут должен быть в самом низу*/
    path: "/:pathMatch(.*)*",
    component: PageNotFound,
    meta: {
      title: "Kaspi.kz",
      additionalClass: "",
      logo: "",
      backRoute: "default",
      shadowed: true,
    },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
